export const contributionGrantCodes = [
  {
    label: "501(c)(1)",
    value: "501(c)(1)"
  },
  {
    label: "501(c)(2)",
    value: "501(c)(2)"
  },
  {
    label: "501(c)(3)",
    value: "501(c)(3)"
  },
  {
    label: "501(c)(4)",
    value: "501(c)(4)"
  },
  {
    label: "501(c)(5)",
    value: "501(c)(5)"
  },
  {
    label: "501(c)(6)",
    value: "501(c)(6)"
  },
  {
    label: "501(c)(7)",
    value: "501(c)(7)"
  },
  {
    label: "501(c)(8)",
    value: "501(c)(8)"
  },
  {
    label: "501(c)(9)",
    value: "501(c)(9)"
  },
  {
    label: "501(c)(10)",
    value: "501(c)(10)"
  },
  {
    label: "501(c)(11)",
    value: "501(c)(11)"
  },
  {
    label: "501(c)(12)",
    value: "501(c)(12)"
  },
  {
    label: "501(c)(13)",
    value: "501(c)(13)"
  },
  {
    label: "501(c)(14)",
    value: "501(c)(14)"
  },
  {
    label: "501(c)(15)",
    value: "501(c)(15)"
  },
  {
    label: "Other",
    value: "Other"
  }
];
